<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Report Proctor Peserta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
			{ width: "50px", label: "No", name: "-" },
			{ width: "auto", label: "Kode Tes", name: "kode_tes" },
			{ width: "auto", label: "Pelaksanaan", name: "-" },
			{ width: "auto", label: "Keterangan", name: "keterangan" },
			{ width: "auto", label: "Tanggal Mulai", name: "tanggal_mulai" },
			{ width: "auto", label: "Tanggal Selesai", name: "tanggal_selesai" },
			{ width: "auto", label: "Status ", name: "-" },
			{ width: "200px", label: "Aksi", name: "-" }
		];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Report Proctor Peserta",
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,

      tableData: {
        columns: columns,
        sortKey: "kode_tes",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          draw: 0,  
          page: 1,
          per_page: 10,
          search: "",
          column: 'kode_tes',
          dir: 'asc',
          kode_tes: "",
          jadwal_pelaksanaan_idjadwal_pelaksanaan:"",
          keterangan:"",
          status: "",
          tanggal_mulai: "",
          tanggal_selesai: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },

      listFilterJadwalPelaksanaan: [],

    };
  },
  async mounted() {
    this.getFilterPelaksanaan();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);

    await this.getDataTable();
  },
  methods: {
    async getFilterPelaksanaan() {
      const data = await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "referensi/jadwal-pelaksanaan/all",
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data.data)
        .catch((err) => {
          console.log("err get jadwal pelaksanaan", err);
          return false;
        });
      if (data) {
        this.listFilterJadwalPelaksanaan = data;
      }
    },

		formatDate(date) {
			if (!date) return "-";
			const [datePart, timePart] = date.split(" ");
			const [year, month, day] = datePart.split("-");
			return `${day}-${month}-${year} ${timePart}`;
		},
		
    getDataTable(resetPage = true) {
      this.tableData.filter.page = resetPage ? 1 : this.tableData.filter.page;
      let self = this;
      self.tableData.loading = true;
      self.tableData.filter.draw++;

      let payload = { ...this.tableData.filter };
      if (payload.jadwal_pelaksanaan_idjadwal_pelaksanaan) {
        payload.jadwal_pelaksanaan_idjadwal_pelaksanaan =
          payload.jadwal_pelaksanaan_idjadwal_pelaksanaan?.idjadwal_pelaksanaan;
      }
      payload.kode_tes_active = localStorage.kode_tes_active;
      if (resetPage) {
        this.tableData.filter.page = 1;
      }

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta",
        params: payload,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.tableData.pagination.currentPage = response_data_fix.current_page;
            self.tableData.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir = self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");      
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    
    detail(row) {
      this.$router.push({
        name: "report-proctor-peserta-detail-batch",
        query: { idjadwal: row.idjadwal },
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="form-group col-md-2">
                    <label for="filterKodeTes">Kode Tes</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Kode Tes"
                      v-model="tableData.filter.kode_tes"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label for="filterKeterangan">Pelaksanaan</label>
                    <v-select
                      id="filterKeterangan"
                      class="style-chooser"
                      :options="listFilterJadwalPelaksanaan"
                      :deselectFromDropdown="true"
                      label="pelaksanaan"
                      v-model="
                        tableData.filter.jadwal_pelaksanaan_idjadwal_pelaksanaan
                      "
                      placeholder="Filter Pelaksanaan"
                      v-on:update:modelValue="getDataTable()"
                      @clear="getDataTable()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label for="filterKeterangan">Keterangan</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Keterangan"
                      v-model="tableData.filter.keterangan"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label for="statusTable">Status</label>
                    <select
                      class="form-select"
                      id="statusTable"
                      v-model="tableData.filter.status"
                      @change="getDataTable()"
                    >
                      <option selected value="all">Semua</option>
                      <option value="0">Batal</option>
                      <option value="1">Aktif</option>
                      <option value="2">Selesai</option>
                      <option value="3">Draft</option>
                      <option value="4">Disable</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label for="filterTanggalMulai">Tanggal Mulai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalMulai"
                      v-model="tableData.filter.tanggal_mulai"
                      @change="getDataTable()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label for="filterTanggalSelesai">Tanggal Selesai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalSelesai"
                      v-model="tableData.filter.tanggal_selesai"
                      @change="getDataTable()"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-12">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            id="showpaginatetable"
                            style="width: 100%"
                            v-model="tableData.per_page"
                            @change="
                              tableData.page = 1;
                              getDataTable();
                            "
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <datatable
                :columns="tableData.columns"
                :sortKey="tableData.sortKey"
                :sortOrders="tableData.sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="tableData.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="!tableData.data || tableData.data.length === 0" class="text-center">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in tableData.data"
                    :key="row_data.idjadwal_peserta"
                  >
                    <td class="text-center">
                      {{ (tableData.pagination.currentPage - 1) * (tableData.filter.per_page || 10) + key_data + 1 }}
                    </td>
                    <td class="text-center">{{ row_data.kode_tes }}</td>
										<td class="text-center">{{ row_data.jadwal_pelaksanaan?.pelaksanaan || "-" }}</td>
                    <td class="text-center">{{ row_data.keterangan }}</td>
                    <td class="text-center">{{ row_data.tanggal_mulai }}</td>
                    <td class="text-center">{{ row_data.tanggal_selesai }}</td>
                    <td class="text-center">
                      <div v-if="row_data.status_jadwal == 0">
                        <div
                          class="badge badge-pill badge-soft-danger font-size-12"
                        >
                          Batal
                        </div>
                      </div>
                      <div v-else-if="row_data.status_jadwal == 1">
                        <div
                          class="badge badge-pill badge-soft-info font-size-12"
                        >
                          Aktif
                        </div>
                      </div>
                      <div v-else-if="row_data.status_jadwal == 2">
                        <div
                          class="badge badge-pill badge-soft-success font-size-12"
                        >
                          Selesai
                        </div>
                      </div>
                      <div v-else-if="row_data.status_jadwal == 3">
                        <div
                          class="badge badge-pill badge-soft-warning font-size-12"
                        >
                          Draft
                        </div>
                      </div>
                      <div v-else-if="row_data.status_jadwal == 4">
                        <div
                          class="badge badge-pill badge-soft-danger font-size-12"
                        >
                          Disable
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn btn-info btn-sm"
                          @click="detail(row_data)"
                        >
                          <i class="fa fa-external-link-alt"></i> Detail
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="tableData.pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
